export enum Colors {
  Black = 'var(--stk-color-black)',
  White = 'var(--stk-color-white)',
  BrandBlue = 'var(--stk-color-brand-blue)',
  BrandCornflower = 'var(--stk-color-brand-cornflower)',
  BrandCharcoal = 'var(--stk-color-brand-charcoal)',
  BrandSlate = 'var(--stk-color-brand-slate)',
  BrandSteel = 'var(--stk-color-brand-steel)',
  BrandStone = 'var(--stk-color-brand-stone)',
  RankSuperGreen = 'var(--stk-color-rank-super-green)',
  RankSuckerRed = 'var(--stk-color-rank-sucker-red)',
  RankStrongGreen = 'var(--stk-color-rank-strong-green)',
  RankAmber = 'var(--stk-color-rank-amber)',
  RankWarmYellow = 'var(--stk-color-rank-warm-yellow)',
  RankNeutral = 'var(--stk-color-rank-neutral)',
  AccentTeal = 'var(--stk-color-accent-value-teal)',
  AccentBargainPurple = 'var(--stk-color-accent-bargain-purple)',
  AccentIncomeGold = 'var(--stk-color-accent-income-gold)',
  Text1 = 'var(--stk-color-text-1)',
  Text2 = 'var(--stk-color-text-2)',
  Text3 = 'var(--stk-color-text-3)',
  TextInvert = 'var(--stk-color-text-invert)',
  Action = 'var(--stk-color-action)',
  ActionHighlight = 'var(--stk-color-action-highlight)',
  ActionHover = 'var(--stk-color-action-hover)',
  Danger = 'var(--stk-color-danger)',
  DangerHighlight = 'var(--stk-color-danger-highlight)',
  DangerHover = 'var(--stk-color-danger-hover)',
  Success = 'var(--stk-color-success)',
  SuccessHighlight = 'var(--stk-color-success-highlight)',
  SuccessHover = 'var(--stk-color-success-hover)',
  BorderColor = 'var(--stk-border-color)',
}
